<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="bookingpaymentreasons.icon" class="mr-1"></i>
                        <span>{{ bookingpaymentreasons.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">

                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Code" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="code" :debounce="bookingpaymentreasons.debounce"
                                            placeholder="Code"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!code"
                                                @click="code = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Description" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="description" :debounce="bookingpaymentreasons.debounce"
                                            placeholder="Description"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!description"
                                                @click="description = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="bookingpaymentreasons"
                        :icon="bookingpaymentreasons.icon" :busy="bookingpaymentreasons.busy"
                        :toolbarlibrary="bookingpaymentreasons.toolbarlibrary" :tools="bookingpaymentreasons.tools"
                        :badges="bookingpaymentreasons.badges" :fields="bookingpaymentreasons.fields"
                        :items="bookingpaymentreasons.items" :limit="bookingpaymentreasons.limit"
                        :downloaded="bookingpaymentreasons.downloaded" :showpages="true"
                        :offset="bookingpaymentreasons.offset" :page="bookingpaymentreasons.page"
                        @load="bookingpaymentreasons_load" @click="bookingpaymentreasons_click"
                        @changed="bookingpaymentreasons_click('save', $event)" @select="bookingpaymentreasons_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="bookingpaymentreasons.selected" :config="cconfig"
                    @discard="bookingpaymentreasons_click('discard')" @go="bookingpaymentreasons_click('go')">
                </component>
            </div>
            <b-card-footer class="mt-2 ml-1">
                <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-cogs mr-2"></i>Setup All
                    </b-button>
                </div>     
            </b-card-footer>

        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import BookingPaymentReasonEdit from "./Components/Setup_BookingPaymentReasonEdit";

export default {
    name: "BookingPaymentReasons",
    components: { BookingPaymentReasonEdit },
    watch: {
        async code() {
            await this.bookingpaymentreasons_load(0);
        },
        async description() {
            await this.bookingpaymentreasons_load(0);
        },

    },
    data() {
        return {
            description: null,
            code: null,

            bookingpaymentreasons: {
                title: "Booking Forms Payment Reasons",
                icon: "fa fa-list",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                tools: "go,filter,download,clipboard,add,edit,deleteconfirm",
                toolbarlibrary: [],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-50px",
                    },
                    {
                        key: "code",
                        label: "Code",
                        sortable: true,
                    },
                    {
                        key: "description",
                        label: "Description",
                        sortable: true,
                    },

                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },

                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();

        await this.bookingpaymentreasons_load();
    },

    methods: {
        accessdenied() {
            this.bookingpaymentreasons.denied = [];
            if (!this.user.permissions.includes("setup_bookingpaymentreasons.admin")) {
                this.bookingpaymentreasons.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("setup_bookingpaymentreasons.admin")) {
                this.bookingpaymentreasons.denied.push("add");
                this.bookingpaymentreasons.denied.push("save");
            }

        },

        async bookingpaymentreasons_load(offset, limit, page) {
            let state = this.bookingpaymentreasons;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                code: this.code,
                description: this.description,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                query setup_bookingformspayreasons(
                    $limit: Int
                    $offset: Int
                    $code: String
                    $description: String
                       
              ) {
                setup_bookingformspayreasons(
                  limit: $limit
                  offset: $offset
                  description: $description
                  code: $code                                      
                ) {
                  id
                  code
                  description                
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
                    variables,
                });

                // USE LOCAL VARIABLE


                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_bookingformspayreasons
                } else {
                    state.items = response.data.setup_bookingformspayreasons;
                }



            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async bookingpaymentreasons_click(a, ss) {

            let state = this.bookingpaymentreasons;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.bookingpaymentreasons_load(0, 0);
                    break;
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    await this.bookingpaymentreasons_load();
                    break;

                case "go":
                    this.component = null;
                    await this.bookingpaymentreasons_load();
                    break;
                case "add":
                case "edit":
                    this.component = "BookingPaymentReasonEdit";
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;
            }
        },
        async bookingpaymentreasons_select(ss, tools) {

            let state = this.bookingpaymentreasons;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async saveit(ss) {

            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                mutation setup_bookingformspayreasons_save(
                  $rows: [setup_bookingformspayreasons_input]             
                ) {
                  setup_bookingformspayreasons_save(rows: $rows) {
                    id
                    code
                  description         
                  }
                }
              `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                mutation setup_bookingformspayreasons_delete(
                  $rows: [setup_bookingformspayreasons_input]
                ) {
                  setup_bookingformspayreasons_delete(rows: $rows) {
                    id
                  }
                }
              `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.bookingpaymentreasons_load(0);
        },
    },
};
</script>

<style></style>